import React from 'react';
import RadioButton from './RadioButton';
import './RadioGroup.scss';

const RadioGroup = ({ 
  id, 
  label, 
  options, 
  name, 
  selectedValue, 
  onChange
}) => {
  return (
    <li className="form-line radio-question" data-type="control_radio" id={id}>
      <label className="form-label form-label-top form-label-auto" id={`label_${id}`} aria-hidden="false">
        {label}
      </label>
      <div id={`cid_${id}`} className="form-input-wide" data-layout="full">
        <div className="form-single-column" role="group" aria-labelledby={`label_${id}`} data-component="radio">
          {options.map((option, index) => (
            <RadioButton
              key={`${id}_${index}`}
              ariaDescribedBy={`label_${id}`}
              id={`input_${id}_${index}`}
              name={name}
              value={option.value}
              onChange={onChange}
              checked={selectedValue === option.value}
              label={option.label}
            />
          ))}
        </div>
      </div>
    </li>
  );
};

export default RadioGroup; 